import { useCall } from "@/hooks/useCall/useCall";
import { useTrack } from "@/hooks/useTrack/useTrack";

export function useTracking() {
  const { call } = useCall();
  const { track } = useTrack();

  const onClick = () => {
    track("call_evaluation_cancelled", {
      call_id: call?.id,
    });
  };

  return { onClick };
}
